/**
 * Legacy react-markdown-editor-lite underline used non-standard `++text++`.
 * Newer editor inserts HTML <u> directly. Convert leftover `++` markers so
 * preview/render still shows a real underline (with rehype-raw).
 */
export function convertMarkdownUnderlineMarkers(markdown: string): string {
  if (!markdown.includes('++')) return markdown

  return markdown.replace(/\+\+([^\n+]+?)\+\+/g, '<u>$1</u>')
}
